import React from "react";
import "../PrivacyPolicy/PrivacyPolicy.css";

const DataDeletion = () => {
  return (
    <div className="policy-page">
      <section className="policy-hero">
        <h1>Data Deletion</h1>
        <p className="policy-tagline">How to request deletion of your StoryBuddy data</p>
      </section>

      <section className="policy-section">
        <h2>Your Right to Delete Your Data</h2>
        <p>
          You have the right to request deletion of all personal data associated with your
          StoryBuddy account, including your profile, child profiles, stories, and any
          other information we hold about you.
        </p>
      </section>

      <section className="policy-section">
        <h2>What Gets Deleted</h2>
        <p>
          Upon receiving a verified deletion request, we will permanently delete:
        </p>
        <div className="deletion-steps">
          <ol>
            <li>Your account profile (name, email)</li>
            <li>All child profiles linked to your account</li>
            <li>All stories you have created</li>
            <li>Your likes, ratings, and comments</li>
            <li>Any stored preferences or settings</li>
          </ol>
        </div>
        <p style={{ marginTop: "1rem" }}>
          Note: Stories you have made public may be retained in anonymized form unless
          you specifically request their removal. Images stored on Cloudinary will also
          be deleted within 30 days.
        </p>
      </section>

      <section className="policy-section">
        <h2>How to Request Deletion</h2>
        <p>Send an email to us with the subject line "Data Deletion Request" from the
          email address associated with your StoryBuddy account:</p>
        <div className="deletion-contact">
          <p><strong>Email:</strong>{" "}
            <a href="mailto:storybuddyorg@gmail.com">storybuddyorg@gmail.com</a>
          </p>
          <p><strong>Subject:</strong> Data Deletion Request</p>
          <p><strong>Include:</strong> The email address linked to your account</p>
        </div>
      </section>

      <section className="policy-section">
        <h2>Processing Time</h2>
        <p>
          We will process your deletion request within <strong>30 days</strong> of receipt
          and send a confirmation email once complete. If you signed in via Facebook,
          you can also manage your data through Facebook's{" "}
          <a
            href="https://www.facebook.com/settings?tab=applications"
            target="_blank"
            rel="noopener noreferrer"
          >
            App Settings
          </a>{" "}
          by removing StoryBuddy from your connected apps.
        </p>
      </section>

      <section className="policy-section">
        <h2>Facebook-Specific Deletion</h2>
        <p>
          If you used Facebook Login, Facebook may send us a data deletion request on your
          behalf when you remove StoryBuddy from your Facebook connected apps. We honor all
          such requests within 30 days. After deletion, you will receive a confirmation with
          a reference code.
        </p>
      </section>

      <section className="policy-section">
        <h2>Questions</h2>
        <p>
          If you have any questions about data deletion, contact us at{" "}
          <a href="mailto:storybuddyorg@gmail.com">storybuddyorg@gmail.com</a> or visit
          our <a href="/privacy">Privacy Policy</a>.
        </p>
      </section>
    </div>
  );
};

export default DataDeletion;
